import { HeaderHelpButton } from 'app/components/header-help-button';
import { MOBILE_HOME_HEADER_ICON_SIZE } from 'app/components/mobile-home-header-constants';
import { NotificationsButton } from 'app/components/notifications-button';
import { Row } from 'app/design/primitives/box';
import { createTheme as createDSTheme } from 'app/shopify';

import React from 'react';
import { Platform } from 'react-native';

const theme = createDSTheme();

export function MobileHomeHeaderRight() {
  return (
    <Row
      alignItems="center"
      gap="spacing.general.x2"
      style={{
        marginRight: Platform.OS === 'web' ? theme.spacing['spacing.general.x2'] : -theme.spacing['spacing.general.x2'],
      }}
    >
      <HeaderHelpButton iconSize={MOBILE_HOME_HEADER_ICON_SIZE} />
      <NotificationsButton />
    </Row>
  );
}
